import { render } from "./BackToLegacyButton.vue?vue&type=template&id=5b2badd1&scoped=true"
import script from "./BackToLegacyButton.vue?vue&type=script&lang=js"
export * from "./BackToLegacyButton.vue?vue&type=script&lang=js"

import "./BackToLegacyButton.vue?vue&type=style&index=0&id=5b2badd1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2badd1"]])

export default __exports__